import { makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React, { FC } from "react";
import { TheCycleverseTheme } from "src/theme";
import { BreakPointsSlider } from "../BreakPointsSlider";
import {
  CalculatorElevatedText,
  CalculatorInputHeadline,
  CalculatorTextCenter,
  CalculatorTextHighlight,
} from "./CalculatorTypography";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: "50px",
  },
  sliderContainer: {
    width: "100%",
  },

  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: "#bababa",
  },
  dividerLabel: {
    width: "40px",
    height: "40px",
    borderRadius: "20px",
    marginTop: "-20.5px",
  },

  dividerContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
    justifyItems: "center",
    justifyContent: "center",
  },
}));

type SliderTypes = {
  sliderTopCenteredLabel?: string;
  selectorValue?: number;
  sliderStep: number;
  onChange: Function;
  minValue: number;
  maxValue: number;
  inputNumber?: string;
  marks?: { value: number; label?: string }[];
};

const CalculatorSlider: FC<SliderTypes> = ({
  sliderTopCenteredLabel,
  selectorValue,
  sliderStep,
  onChange,
  minValue,
  maxValue,
  inputNumber,
  marks,
}) => {
  const classes = useStyles();
  const { t } = useTranslation("lebenserwartungsrechner");
  return (
    <div className={`${classes.container}`}>
      <div className={classes.dividerContainer}>
        <div className={classes.divider}></div>
        <img
          className={classes.dividerLabel}
          src={`/images/calculators/number_icons/orange_${inputNumber}.svg`}
          alt="number"
        />
        <CalculatorInputHeadline>{t("inputTitle5")}</CalculatorInputHeadline>
      </div>
      <div className={classes.sliderContainer}>
        <CalculatorElevatedText>
          <CalculatorTextCenter>
            <CalculatorTextHighlight>{sliderTopCenteredLabel}</CalculatorTextHighlight>
          </CalculatorTextCenter>
        </CalculatorElevatedText>
        <BreakPointsSlider
          value={selectorValue}
          min={minValue}
          max={maxValue}
          step={sliderStep || 1}
          onChange={(_, value) => onChange(Number(value))}
          marks={marks}
        />
      </div>
    </div>
  );
};

export default CalculatorSlider;
